import { render, staticRenderFns } from "./WorkBaseHeaderBar.vue?vue&type=template&id=dca410d0"
import script from "./WorkBaseHeaderBar.vue?vue&type=script&lang=js"
export * from "./WorkBaseHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseHeaderBar.vue?vue&type=style&index=0&id=dca410d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports